import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { B as e, L as a } from "./navigation-expanded.constants-0bd33ea9-3a4ddf9d.js";
import { Ge as o, hi as t } from "./abstract-base-8edf0a84-e11d45a3.js";
import "./state-b4c9cc73-ee633f6c.js";
import "./query-assigned-ba663908-228b08f4.js";
import "./query-24926cff-3eb94bfb.js";
var n = o(_templateObject || (_templateObject = _taggedTemplateLiteral(["[beacon-tag-name=beacon-navigation-footer]{--heritage-navigation-expanded-title-color: var(--beacon-color-text-default)}[beacon-tag-name=beacon-navigation-footer] a{font:var(--beacon-system-font-weight-light, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));color:var(--beacon-system-color-text-link, var(--beacon-color-hyperlink-default))}[beacon-tag-name=beacon-navigation-footer] a:not(:hover,:focus){text-decoration:none}[beacon-tag-name=beacon-navigation-footer]:not(:last-of-type){border-block-end:var(--beacon-system-width-border-mini, var(--beacon-border-widths-hairline)) solid var(--beacon-system-color-border-0, var(--beacon-footer-divider-color-border));padding-block-end:var(--beacon-system-space-micro-jumbo, var(--beacon-space-micro-jumbo))}@media (min-width: 960px){[beacon-tag-name=beacon-navigation-footer]:not(:last-of-type){border-block-end:0;padding-block-end:0}}\n"]))),
  r = o(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([".level-2 ::slotted([slot=title]){font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-serif-headline-50, var(--beacon-headline-font-size-50)/var(--beacon-headline-font-line-height-module-50) var(--beacon-font-family-default))}\n"])));
var i = /*#__PURE__*/function (_t) {
  _inherits(i, _t);
  function i() {
    var _this;
    _classCallCheck(this, i);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments)), _this.beaconTagName = e.beaconFooterNavTagName;
    return _this;
  }
  _createClass(i, [{
    key: "setLevel",
    value: function setLevel() {
      this.level = 2;
    }
  }, {
    key: "setLevel2GridTemplate",
    value: function setLevel2GridTemplate() {
      this.style.setProperty("--expanded-nav-grid-template", "1");
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(i), "styles", this), r];
    }
  }, {
    key: "lightDOMStyles",
    get: function get() {
      return [_get(_getPrototypeOf(i), "lightDOMStyles", this), n];
    }
  }]);
  return i;
}(t(a));
i.tagName = e.beaconFooterNavTagName;
export { i as BeaconNavigationFooter };